export const UMDataAction = {
    UPDATE_UM_DATA: 'UPDATE_UM_DATA',
};

export const UMDataReducer = (state, action) => {
    switch (action.type) {
    case UMDataAction.UPDATE_UM_DATA:
        return {
            ...action.payload,
        };
    default:
        return state;
    }
};
